/**
 * This is not that React-y of a component. I am manipulating the DOM by hand, because dealing with state and render and timing was getting complicated.
 */

import React, { Component } from 'react';
import styled from 'styled-components';

const LI = styled.li`
  font-family: monospace;
  list-style: none;

  .title {
    font-weight: bold;
  }
`;
class CycleItems extends Component {
  
  constructor(props) {
    console.log('wtf')
    super(props);

    this.itemInd = 1;
    this.items = this.props.items.map(item => `${item} `);

    if (props.byLine) {
      setInterval(() => {
        if (this.text) this.text.textContent = this.items[this.itemInd];

        const ind = ++this.itemInd % this.items.length;
        if (this.text) this.text.textContent = this.items[ind];
      }, 400);
    } else {
      this.characterInd = 0;
      // add a space to the end of the items (for text-breaking purposes)

      this.timeouts = [];
      this.raf = null;
    }
  }

  componentDidMount() {
    if (!this.props.byLine) {
      this.nextCharacter();
    }
  }

  componentWillUnmount() {
    if (!this.props.byLine) {
      this.timeouts.forEach(timeout => clearTimeout(timeout));
      if (this.props.byLine) {
        window.cancelAnimationFrame(this.raf);
      }
    }
  }

  nextCharacter() {
    this.raf = window.requestAnimationFrame(() => {
      let letter;
      let textContent = (this.text && this.text.textContent) ? this.text.textContent : ''
      // if (this.text && this.text.textContent) {
        // debugger;
      if (this.text && textContent.length - 1 < this.characterInd) {
        // if the current textContent doesn't have a character at character ind, just add to textContent
        letter = letterThatMightBeAnEmoji(
          this.items[this.itemInd].substr([this.characterInd], 2)
        );
        this.text.textContent += letter;
      } else if (this.characterInd < this.items[this.itemInd].length) {
        letter = letterThatMightBeAnEmoji(
          this.items[this.itemInd].substr([this.characterInd], 2)
        );
        // replace the text at that ind
        this.text.textContent =
          textContent.substr(0, this.characterInd) +
          letter +
          textContent.substr(
            this.characterInd + letter.length,
            textContent.length - this.characterInd - letter.length
          );
      } else {
        this.text.textContent = `${textContent.substr(
          0,
          this.characterInd
        )}${' '}${textContent.substr(
          this.characterInd + 1,
          textContent.length - this.characterInd - 1
        )}`;
      }

      this.characterInd += letter ? letter.length : 1;

      if (
        this.characterInd >= this.items[this.itemInd].length &&
        this.characterInd >= textContent.length
      ) {
        this.itemInd = (this.itemInd + 1) % this.items.length;
        this.characterInd = 0;
        this.timeouts.push(setTimeout(() => this.nextCharacter(), 1000));
        return;
      }
      this.nextCharacter();
      // }
    });
  }

  render() {
    return (
      <LI>
        <p>
          <span className="title">{this.props.title}</span>{' '}
          <span
            ref={text => {
              this.text = text;
            }}
          />
          <span />
        </p>
      </LI>
    );
  }
}
export default CycleItems;

function letterThatMightBeAnEmoji(str) {
  return str.match(/([\uD800-\uDBFF][\uDC00-\uDFFF])/)
    ? str.substr(0, 2)
    : str.substr(0, 1);
}



// WEBPACK FOOTER //
// ./src/components/CycleItems.js